import { iModalsState, tModalName } from "../../interfaces/interfaces";
import { eModalsActionTypes, tModalsAction } from "./modalsTypes";

const initialState: iModalsState = {
	modalsIds: {
		selectOption: 0,
		createOption: 0,
		history: 0,
		mobileMenu: 0,
		approve: 0,
		makeOrder: 0,
		takeOrder: 0,
		requestUncreateBorrow: 0,
		orderBook: 0,
		info: 0,
		chrBalancesModal: 0,
		wallet: 0,
		confirmation: 0,
		success: 0,
		transaction: 0,
		finalizeExercise: 0,
	},
	openedModals: [],
}

export const modalsReducer = (state = initialState, action: tModalsAction): iModalsState => {
	switch (action.type){

		case eModalsActionTypes.CLEAR_STATE:
			return initialState
		;

		case eModalsActionTypes.OPEN_NEW_MODAL:
			// let modalsIdsCopy = structuredClone(state.modalsIds);    // JS should be updated
			let modalsIds: {[K in tModalName]: number} = Object.assign(state.modalsIds);
			modalsIds[action.payload.modalName] = state.modalsIds[action.payload.modalName] + 1;

			return {
				...state,
				openedModals: state.openedModals.concat(
					action.payload.modalName === 'mobileMenu'
					// action.payload.modalName === 'chrBalancesModal'
					// (action.payload.modalName === 'mobileMenu' || action.payload.modalName === 'chrBalancesModal')	// nonId
						? {modalName: action.payload.modalName, modalId: undefined}
						: action.payload.modalName === 'selectOption'	// exactId
							? action.payload
							: { ...action.payload, modalId: state.modalsIds[action.payload.modalName] }
				),
				modalsIds,
			}
		;

		case eModalsActionTypes.CLOSE_MODAL:
			return {
				...state,
				openedModals: state.openedModals.filter(modal =>
					!(modal.modalName === action.payload.name && (modal.modalId? modal.modalId === action.payload.id : true))
				)
			}
		;

		default: return state;
	}
}